var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ce-blob-button-group',_vm._b({on:{"show-fork-suggestion":_vm.onShowForkSuggestion}},'ce-blob-button-group',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }